import { defineStore } from "pinia";

export const useEvaluationFileModelStore = defineStore('evaluationFileModel', {
    state: () => ({
        evaluationFileModel: {},
        evaluationFileModels: [],
    }),
    actions: {
        setEvaluationFileModel(evaluationFileModel) {
            this.evaluationFileModel = evaluationFileModel
        },
        setEvaluationFileModels(evaluationFileModels) {
            this.evaluationFileModels = evaluationFileModels
        },
        addEvaluationFileModel(evaluationFileModel) {
            this.evaluationFileModels.unshift(evaluationFileModel)
        },
        updateEvaluationFileModel(evaluationFileModel) {
            let index = this.evaluationFileModels.findIndex(cl => cl.id === evaluationFileModel.id)
            this.evaluationFileModels.splice(index, 1, evaluationFileModel)
        },
        deleteEvaluationFileModel(evaluationFileModel) {
            let index = this.evaluationFileModels.findIndex(cl => cl.id === evaluationFileModel.id)
            this.evaluationFileModels.splice(index, 1)
        },
    },
});